<section class="content head">
  <div class="content-wrapper finding-details">
    <iaud-audit-title [audit]="audit"></iaud-audit-title>
    <iaud-breadcrumb class="finding-details__breadcrumbs" [breadcrumbList]="breadcrumbs"></iaud-breadcrumb>
    <div class="finding-details__buttons" *ngIf="finding?.status===findingStatus.DRAFT">
      <button mat-raised-button class="inverted right-margin" routerLink="/audit/{{auditId}}">Finish Later</button>
      <button mat-raised-button [color]="'accent'" (click)="markAsReady()" [disabled]="!canReady()">
          <mat-spinner *ngIf="isMarkingReady$ | async" [diameter]="25"></mat-spinner>
          Ready To Submit
      </button>
    </div>
    <mat-card class="finding-details__panel" *ngIf="finding">
      <div class="finding-details__panel__header">
        <mat-card-title>Finding Details</mat-card-title>
        <button mat-raised-button class="edit-button" (click)="editFinding()" *ngIf="finding?.status===findingStatus.DRAFT">Edit</button>
      </div>
  
      <div class="finding-details__panel__values">
        <div class="finding-details__panel__values--id iaud-value-container">
          <label for="finding-id">Finding id:</label>
          <p id="finding-id">{{ finding.findingId }}</p>
        </div>
  
        <div class="finding-details__panel__values--title iaud-value-container">
          <label for="finding-title">Finding title:</label>
          <p id="finding-title">{{ finding.findingTitle }}</p>
        </div>
  
        <div class="finding-details__panel__values--code iaud-value-container">
          <label for="finding-code">Finding code:</label>
          <p id="finding-code">{{ finding.findingCode }}</p>
        </div>
  
        <div class="finding-details__panel__values--owner-group iaud-value-container">
          <label for="finding-owner-group">Deviation Owners:</label>
          <p id="finding-owners" *ngFor="let owner of finding.findingOwner">
              {{ owner.fullName }}
            </p>
            </div>
  
        <div class="finding-details__panel__values--description iaud-value-container description">
          <label for="finding-description">Finding description:</label>
          <p id="finding-description">{{ finding.findingDescription }}</p>
        </div>
  
        <div class="finding-details__panel__values--due-date iaud-value-container">
          <label for="finding-due-date">Evidence Approval Due Date</label>
          <p id="finding-due-date">{{ finding.dueDate | date:dateFormat }}</p>
        </div>
  
        <div class="finding-details__panel__values--status iaud-value-container">
          <label for="finding-status">finding status:</label>
          <p id="finding-status">{{ finding.status }}</p>
        </div>    
      </div>
    </mat-card>    
    </div>
</section>
<iaud-capa-list [findingId]="findingId" 
                [auditId]="auditId" 
                [canAdd]="finding?.status===findingStatus.DRAFT"
                [reloadCapa]="reloadCapa"
                [evidence]="toEvidence"></iaud-capa-list>